import { Card, Grid } from '@mui/material';
import dayjs from 'dayjs';
import { TextPlaceholder } from '../../../../ui/components/pure/placeholders/text.placeholder';
import { useDashboardStatsContext } from '../../context/use-dashboard-stats.context';
import { MedianTimeInLockerState } from '../../hooks/useMedianTimeInLocker';
import { TimeInLockerHeader } from './time-in-locker-header/time-in-locker-header.component';
import { useTimeInLockerStyles } from './time-in-locker.styles';

const nbsp = '\u00A0';

export function TimeInLocker() {
  const { medianTimeInLocker } = useDashboardStatsContext();

  const duration = dayjs.duration({ seconds: medianTimeInLocker.data.medianTime });
  const exactDays = duration.asDays();
  const days = Math.floor(duration.asDays());
  const exactHours = dayjs.duration({ days: exactDays - days }).asHours();
  const hours = Math.floor(dayjs.duration({ days: exactDays - days }).asHours());
  const minutes = Math.round(dayjs.duration({ hours: exactHours - hours }).asMinutes());

  const showDays = Boolean(days);
  const showHours = Boolean(hours || (days && minutes));
  const showMinutes = Boolean(minutes);

  const dayLabel = showDays ? 'day' + (days > 1 ? 's' : '') : '';

  // eslint-disable-next-line prettier/prettier
  const displayDuration =
    !showDays && !showHours && !showMinutes
      ? '0'
      : `${!showDays ? '' : days + nbsp + dayLabel + (showHours ? ', ' : '')}
         ${!showHours ? '' : hours + nbsp + 'h' + (minutes ? ', ' : '')}
         ${!showMinutes ? '' : minutes + nbsp + 'min'}`;

  const fontSize = days && minutes ? ('small' as const) : ('normal' as const);

  const classes = useTimeInLockerStyles({ fontSize });

  return (
    <Card className={classes.card}>
      <Grid
        container
        sx={{
          justifyContent: 'space-between',
          flexDirection: 'column'
        }}
      >
        <Grid container>
          <TimeInLockerHeader />
        </Grid>
        <Grid>
          <p className={classes.subtitle}>{subtitleMap[medianTimeInLocker.state.completedEventType]}</p>
          {medianTimeInLocker.data.isLoading ? (
            <TextPlaceholder fontSize={26} width="150px" />
          ) : (
            <p className={classes.duration}>{displayDuration}</p>
          )}
        </Grid>
      </Grid>
    </Card>
  );
}

const subtitleMap: Record<MedianTimeInLockerState['completedEventType'], string> = {
  completed: 'Median time between delivery and collection or' + nbsp + 'retrieval',
  collected: 'Median time between delivery and collection',
  retrieved: 'Median time between delivery and retrieval'
};
